import {Grid, Icon, Menu} from 'semantic-ui-react';
import {withRouter} from 'react-router-dom';
import Fetcher from './fetches/fetcher';
import {fetchStudentCourses} from '../../redux/actions/student-course';
import StartStudentCourse from './start-student-course';

function BaseStudentCourseMenu(props) {
  const {studentCourses, match: {path, params: {scId}}} = props;
  const createdStudentCourses = studentCourses.filter(({status}) => (status === 0));
  const startedStudentCourses = studentCourses.filter(({status}) => (status === 1));
  const activeId = getId(scId, startedStudentCourses);
  const activeStudentCourseById = getStudentCourseById(startedStudentCourses, activeId);

  return (
    <Grid stackable>
      <Grid.Column width={4}>
        <Menu fluid vertical>
          {startedStudentCourses.map(studentCourse => (
            <Menu.Item
              key={studentCourse.id}
              active={activeId === studentCourse.id}
              onClick={updateRoute.bind(null, props.history.push, path, scId, studentCourse.id)}
            >
              {studentCourse.name}
            </Menu.Item>
          ))}
          <Menu.Item
            key={0}
            name='شروع کورس جدید'
            active={activeId === 0}
            onClick={updateRoute.bind(null, props.history.push, path, scId, 0)}
          >
            شروع کورس جدید
            <Icon name='plus'/>
          </Menu.Item>
        </Menu>
      </Grid.Column>

      <Grid.Column stretched width={12}>
        {activeId ? (
          props.render(activeStudentCourseById)
        ) : (
          <StartStudentCourse createdStudentCourses={createdStudentCourses}/>
        )}
      </Grid.Column>
    </Grid>
  );
}

function getId(scId, startedStudentCourses) {
  let initialId = parseInt(scId);
  if (isNaN(initialId)) {
    if (startedStudentCourses && startedStudentCourses.length > 0) return startedStudentCourses[0].id;
    return 0;
  }
  const activeStudentCourseById = getStudentCourseById(startedStudentCourses, initialId);
  if (!activeStudentCourseById) return getId();
  return initialId;
}

function updateRoute(push, path, prevId, nextId) {
  if (prevId !== nextId) push(path.replace(':scId?', nextId));
}

function getStudentCourseById(studentCourses, studentCourseId) {
  for (let i = 0; i < studentCourses.length; i++) {
    if (studentCourses[i].id === studentCourseId) return studentCourses[i];
  }
  return null;
}

function StudentCourseMenu(props) {
  return (
    <Fetcher action={fetchStudentCourses} stateSelector={state => state.studentCourses}>
      {studentCourses => (<BaseStudentCourseMenu studentCourses={studentCourses}{...props}/>)}
    </Fetcher>
  );
}

export default withRouter(StudentCourseMenu);
